// extracted by mini-css-extract-plugin
export default {"container":"UploadDropzone_container__10FFl","focused":"UploadDropzone_focused__n90e0","accept":"UploadDropzone_accept__rMDzC","reject":"UploadDropzone_reject__BlgFz"};